import axios from 'axios';

axios.interceptors.request.use(config => {
  if (typeof window === 'undefined') {
    return config;
  }

  const token = window.localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `bearer ${token}`;
  }

  return config;
});

const userService = {
    updatePassword(data){
        return new Promise((resolve, reject) => {
    
          let dataPost = { 
            Login: data.login,
            Senha: data.senha,
            SenhaNova: data.novaSenha,
            SenhaNovaConfirmacao: data.confirmacaoSenha,
          };

          axios
            .post('api/login/altera_senha', dataPost)
            .then(response => {
              resolve(response.data);
            })
            .catch(response => {
              reject(response.status);
            });
        });
  },

  resetForgottenPassword(login) {
    return new Promise((resolve, reject) => {
      axios.post('/api/login/esqueci_senha', login)
            .then(response => {
              //console.log('service ' + response);
              resolve(response);
          })
            .catch(response => {
              reject(response);
          });
      });
  },
  updatePasswordByMail(login){
    return new Promise((resolve, reject) => {
      axios
        .post('/api/login/altera_senha_email', login)
        .then(response => {
          resolve(response.data);
        })
        .catch(response => {
          reject(response.status);
        });
    });
  },
  validarChave(login){
    return new Promise((resolve, reject) => {
      axios
        .post('api/login/validar_chave_alteracao', login)
        .then(response => {
          resolve(response.data);
        })
        .catch(response => {
          reject(response.status);
        });
    });
  },   
};

export default userService;